var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9C22.75 8.58579 22.4142 8.25 22 8.25C21.5858 8.25 21.25 8.58579 21.25 9H22.75ZM16 2.75C16.4142 2.75 16.75 2.41421 16.75 2C16.75 1.58579 16.4142 1.25 16 1.25V2.75ZM17 21.25H7V22.75H17V21.25ZM2.75 17V7H1.25V17H2.75ZM21.25 9V17H22.75V9H21.25ZM7 2.75H16V1.25H7V2.75ZM7 21.25C4.65279 21.25 2.75 19.3472 2.75 17H1.25C1.25 20.1756 3.82436 22.75 7 22.75V21.25ZM17 22.75C20.1756 22.75 22.75 20.1756 22.75 17H21.25C21.25 19.3472 19.3472 21.25 17 21.25V22.75ZM2.75 7C2.75 4.65279 4.65279 2.75 7 2.75V1.25C3.82436 1.25 1.25 3.82436 1.25 7H2.75Z",
    fill: "#4F49DF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 21 4)",
    stroke: "#4F49DF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.75L10.5 10.75L13.5 13.25L17 9.25",
    stroke: "#4F49DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.63977cb8.svg";
export { ForwardRef as ReactComponent };